import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { Email } from '../../../common/email';
import { PedidoEmailSendValueObject } from '../pedido-email-send.valueobject';

@Injectable({
    providedIn: 'root'
})
export class PedidoEmailService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Cria o e-mail do pedido */
    create(id: number): Observable<Email> {
        return this.customHttp.get<Email>(`${this.pathApi}/${id}/email`);
    }

    /** Envia o e-mail do pedido */
    send(valueObject: PedidoEmailSendValueObject): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/email`, valueObject, {responseType: 'text'});
    }
}
